export default __webpack_public_path__ + "static/media/PPCIstemi_jpg.3dafc0fa.jpg";